import { Calendar } from "primereact/calendar";
import React, { useState } from "react";
import "./Broadcast.css";
import { Dropdown } from "primereact/dropdown";
import _ from "underscore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SkeletonLine } from "../../../components/Loader/Loader";
import { useBroadcast } from "../../../Hooks/Features/Broadcast/useBroadcast";
import CommanDialog from "../../../components/CommonCompo/CommanDialog/CommanDialog";
import { useCommon } from "../../../Hooks/Common/useCommon";

function Broadcast() {
  const {
    viewList,
    setViewList,
    loader,
    handleCreateNew,
    notificationList,
    notificationData,
    setNotificationData,
    handleSelectNotification,
    showDelete,
    setShowDelete,
    deleteIconId,
    setDeleteIconId,
    handleDelete,
    showNewNotifi,
    broadcastTitle,
    weekDays,
    handleAddWeek,
    handleAddMonth,
    months,
    notifiTypes,
    handleReset,
    handleSave,
    visible,
    setVisible,
  } = useBroadcast();
  const { getValuePermission } = useCommon();

  const [deleteId, setDeleteId] = useState(null);

  return (
    <>
      {!getValuePermission("broadcast_tab") &&
        <div className="broadcast-main-container">
          <div className={`broadcast-notifi-list ${viewList ? "list-view" : ""}`}>
            {loader ? (
              <SkeletonLine numSkeletons={6} />
            ) : (
              <div className="broadcast-list-container">
                <div className="row">
                  <div className="col-md-9 col-12">
                    <h5>Notification List</h5>
                  </div>
                  <div className="col-md-3 col-12">
                    <div className="broadcast-create">
                      <button onClick={handleCreateNew}>+</button>
                    </div>
                  </div>
                </div>
                <div className="left-list">
                  {notificationList.map((item, index) => (
                    <div
                      className="each-notifi"
                      key={index}
                      onClick={() => handleSelectNotification(item)}
                      onMouseEnter={() => {
                        setShowDelete(true);
                        setDeleteIconId(item.schedule_id);
                      }}
                      onMouseLeave={() => {
                        setShowDelete(false);
                        setDeleteIconId(null);
                      }}
                    >
                      <span>{item.notification_title}</span>
                      {showDelete && deleteIconId === item.schedule_id && (
                        <div
                          onClick={() => {
                            setVisible(true);
                            setDeleteId(item.schedule_id);
                          }}
                          className="broadcast-trash"
                        >
                          <FontAwesomeIcon
                            className="icon-btn-secondary"
                            icon="fa-solid fa-trash"
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div
              className="broadcast-arrow-btn"
              onClick={() => setViewList(!viewList)}
            >
              <FontAwesomeIcon
                icon="fa-solid fa-angle-right"
                className="broadcast-svg"
              />
            </div>
          </div>

          {showNewNotifi ? (
            <div className="broadcast-main-right-container">
              <h5>{broadcastTitle}</h5>
              <hr />
              <div className="broadcast-container">
                <div className="broadcast-left-panel">
                  <div className="row">
                    <div className="col-md-6 col-12 inspectra-calendar">
                      <label> First Notification: </label>
                      <Calendar className="input-dd"
                        value={notificationData?.startDate}
                        onChange={(e) =>
                          setNotificationData((prev) => ({
                            ...prev,
                            startDate: e.target.value,
                          }))
                        }
                        placeholder="Start date"
                      />
                    </div>
                    <div className="col-md-6 col-12 inspectra-calendar">
                      <label>Until: </label>
                      <Calendar className="input-dd"
                        value={notificationData?.endDate}
                        onChange={(e) =>
                          setNotificationData((prev) => ({
                            ...prev,
                            endDate: e.target.value,
                          }))
                        }
                        placeholder="End date"
                      />
                    </div>
                  </div>
                  <div className="row mt-1">
                    <div className="col-md-6 col-12">
                      <label> Notification Time:</label>
                      <div>
                        <input
                          type="time"
                          id="appt"
                          name="appt"
                          className="input-dd"
                          placeholder="Select time"
                          value={notificationData?.timeSelected}
                          onChange={(e) =>
                            setNotificationData((prev) => ({
                              ...prev,
                              timeSelected: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-1">
                    <div className="col-md-12 col-12">
                      <label>Send notification every:</label>
                      <div className="broadcast-freq">
                        <input
                          value={notificationData?.interval}
                          onChange={(e) =>
                            setNotificationData((prev) => ({
                              ...prev,
                              interval: e.target.value,
                            }))
                          }
                          type="number"
                          min={0}
                        />
                        <div className="freq-opts">
                          <span
                            onClick={() =>
                              setNotificationData((prev) => ({
                                ...prev,
                                freqSelected: "DAI",
                              }))
                            }
                            className={`freq ${notificationData?.freqSelected === "DAI"
                              ? "freq-sel"
                              : ""
                              }`}
                          >
                            Daily
                          </span>

                          <span
                            onClick={() =>
                              setNotificationData((prev) => ({
                                ...prev,
                                freqSelected: "WEE",
                              }))
                            }
                            className={`freq ${notificationData?.freqSelected === "WEE"
                              ? "freq-sel"
                              : ""
                              }`}
                          >
                            Weekly
                          </span>

                          <span
                            onClick={() =>
                              setNotificationData((prev) => ({
                                ...prev,
                                freqSelected: "MON",
                              }))
                            }
                            className={`freq ${notificationData?.freqSelected === "MON"
                              ? "freq-sel"
                              : ""
                              }`}
                          >
                            Monthly
                          </span>

                          <span
                            onClick={() =>
                              setNotificationData((prev) => ({
                                ...prev,
                                freqSelected: "YEA",
                              }))
                            }
                            className={`freq ${notificationData?.freqSelected === "YEA"
                              ? "freq-sel"
                              : ""
                              }`}
                          >
                            Yearly
                          </span>

                          <span
                            onClick={() =>
                              setNotificationData((prev) => ({
                                ...prev,
                                freqSelected: "ONE",
                              }))
                            }
                            className={`freq ${notificationData?.freqSelected === "ONE"
                              ? "freq-sel"
                              : ""
                              }`}
                          >
                            One Time
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {notificationData?.freqSelected === "DAI" && (
                    <div className="row mt-1">
                      <div className="col-md-12 col-12">
                        <label>Hours Interval:</label>

                        <input
                          value={notificationData?.hoursInterval}
                          onChange={(e) =>
                            setNotificationData((prev) => ({
                              ...prev,
                              hoursInterval: e.target.value,
                            }))
                          }
                          type="number"
                          min={0}
                        />
                      </div>
                    </div>
                  )}

                  {notificationData?.freqSelected === "MON" && (
                    <div className="row mt-1">
                      <div className="col-md-12 col-12">
                        <label>Select Multiple Dates:</label>
                        <Calendar
                          className="form-control"
                          selectionMode="multiple"
                          inline
                          value={notificationData?.dates}
                          onChange={(e) =>
                            setNotificationData((prev) => ({
                              ...prev,
                              dates: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  )}

                  {notificationData?.freqSelected === "WEE" && (
                    <div className="weekdays">
                      <div className="broadcast-label">Select Days: </div>
                      {weekDays.map((day, index) => (
                        <div
                          key={index}
                          className={`week-name ${_.includes(notificationData.selectedWeek, day)
                            ? "week-select"
                            : ""
                            }`}
                          onClick={() => handleAddWeek(day)}
                        >
                          {day}
                        </div>
                      ))}
                    </div>
                  )}

                  {notificationData?.freqSelected === "YEA" && (
                    <div className="months">
                      <div className="broadcast-label">Select Months: </div>
                      <div className="broadcast-months">
                        {months.map((month, index) => (
                          <div
                            key={index}
                            className={`month-name ${_.includes(notificationData.selectedMonth, month)
                              ? "month-select"
                              : ""
                              }`}
                            onClick={() => handleAddMonth(month)}
                          >
                            {month}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {notificationData?.freqSelected === "ONE" && (
                    <div className="broadcast-month-calendar">
                      <div className="broadcast-label">Select Date: </div>
                      <Calendar
                        inline
                        value={notificationData?.oneTimeDate}
                        onChange={(e) =>
                          setNotificationData((prev) => ({
                            ...prev,
                            oneTimeDate: e.target.value,
                          }))
                        }
                      />
                    </div>
                  )}
                </div>

                <div className="broadcast-right-panel">
                  <div className="row">
                    <div className="col-md-4 col-12">
                      <label>Notification Type :</label>
                      <Dropdown
                        className="flex"
                        options={notifiTypes}
                        optionLabel="notification_type_name"
                        value={notificationData?.notifiTypeSelected}
                        onChange={(e) =>
                          setNotificationData((prev) => ({
                            ...prev,
                            notifiTypeSelected: e.target.value,
                          }))
                        }
                        placeholder="Notification Type"
                        filter
                        filterInputAutoFocus
                      />
                    </div>
                    <div className="col-md-8 col-12">
                      <label>Notification Title:</label>
                      <input
                        className="form-control"
                        value={notificationData?.notifiTitle}
                        placeholder="Enter notification title"
                        onChange={(e) =>
                          setNotificationData((prev) => ({
                            ...prev,
                            notifiTitle: e.target.value,
                          }))
                        }
                      />                </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-12">
                      <label>Notification Message: </label>
                      <textarea
                        className="form-control"
                        rows={14}
                        value={notificationData?.notifiMessage}
                        placeholder="Enter notification message"
                        onChange={(e) =>
                          setNotificationData((prev) => ({
                            ...prev,
                            notifiMessage: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>


                </div>
              </div>
              <div className="broadcast-save-btn">
                <button className="btn btn-default" onClick={handleReset}>Reset</button>
                <button className="btn btn-primary" onClick={handleSave}>Save</button>
              </div>
            </div>
          ) : (
            <div className="broadcast-main-right-container"></div>
          )}

          <CommanDialog
            visible={visible}
            handleClose={() => setVisible(false)}
            handleFun={() => {
              handleDelete(deleteId);
              setVisible(false);
            }}
            message="Are you sure you want to delete this notification?"
          />
        </div>
      }
    </>
  );
}

export default Broadcast;
